import { DatePipe } from '@angular/common';
import {Component,ElementRef,OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { User } from 'src/app/auth/models';
import { JwtService } from 'src/app/auth/services';
import { IGlobalSearchParam, ISearchGlobalFilter } from 'src/app/shared/models/Global-Search.model';
import { SharedService } from 'src/app/shared/services';
import { IUserActivityLog } from '../../models';
import { UserActivityLogService } from '../../services/user-activity-log.service';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { ILookupCategory } from '../../../shared/models/lookup.model';
import { LookupCategory } from '../../../shared/enums/EnumsVMS';
@Component({
  selector: 'app-user-activity-log',
  templateUrl: './user-activity-log.component.html',
  styleUrls: ['./user-activity-log.component.css'],
  providers: [DialogService, ConfirmationService, MessageService],
})
export class UserActivityLogComponent implements OnInit {
  rangeDates: Date[];
  userActivityLogForm:FormGroup;
  // selectedReports: string[] = [];
  // reports: any[];
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  matchModeOptionsForDropdown: SelectItem[];
  showFilters:boolean;
  showSorting:boolean;
  // invoiceReportSearchParam:IGlobalSearchParam;
  showAddRuleButton:boolean = false;
  searchGlobalFilter: ISearchGlobalFilter[]=[];
  userActivityLogList;
  isshowpaginator:boolean=true;
  loggedInUserProfile: User;
  dateRange:Date[];
  minDate: Date;
  maxDate: Date;
  categoryName;
  //reportTypes;
  selectedReportIds;
  selectedReportEditIds;
  selectedReportEditIdsOnChange;
  selectedReportValid: boolean = true;
  timesheetStartDate;
  timesheetEndDate;
  arrAllReportTypes;
  showTable:boolean = false;
  showIneligibleApplicants: boolean = true ;
  userActivityLogReport = 'UserActivityLogReport.xlsx';

  allColumns = [
    { value: 'fullName', header: 'User' },
    { value: 'companyName', header: 'Company' },
    { value: 'accountType', header: 'Role' },
    { value: 'primaryEmail', header: 'Email' },
    { value: 'vendorCategory', header: 'Vendor Category' },
    { value: 'primaryPhone', header: 'Phone No.' },
    { value: 'primaryPhoneExt', header: 'Ext. No.' },
    { value: 'userStatus', header: 'User Status' },
    { value: 'lastLoginDate', header: 'Last Logged In' },
  ];

  selectedColumns = [
    { value: '#', header: '#' },
    { value: 'fullName', header: 'User' },
    { value: 'companyName', header: 'Company' },
    { value: 'accountType', header: 'Role' },
    { value: 'primaryEmail', header: 'Email' },
    { value: 'vendorCategory', header: 'Vendor Category' },
    // { value: 'primaryPhone', header: 'Phone No.' },
    // { value: 'primaryPhoneExt', header: 'Ext. No.' },
    { value: 'userStatus', header: 'User Status' },
    { value: 'lastLoginDate', header: 'Last Logged In' },
  ];
  userActivityLogSpinner = 'UserActivityLogSpinner'
  selectedUserStatus: any;
  userStatusValues: any;
  lastLoginDateFilterValue: any;
  @ViewChild('dt2', { static: true }) table: any;
  userActivityLogGlobalFilterList: any;
  logPeriodId: any;
  logPeriodDescription: string;
  isLogPeriodSelected: boolean = false;
  // selectedLogPeriodId;
  userActivityLogSearchParam:IGlobalSearchParam;
  public selectedLogPeriodId: Array<any> = [];
  allVendorCategoriesId: any;
  allVendorCategories: ILookupCategory;
  arrVendorCategories;
  selectedVendorCategory: any;
  public selectedVendorCategoryId: Array<any> = [];

  constructor(
    private userActivityLogService: UserActivityLogService,
    public sharedService: SharedService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private jwtService: JwtService,
    private router: Router
  ) { 
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
   }

  ngOnInit(): void {
    this.checkViewPermission();
    this.maxDate = new Date();
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";
    this.filterCondition=[
      { fieldName:"fullName", type: "basic"},
      { fieldName:"companyName", type: "basic"},
      { fieldName:"accountType", type: "basic"},
      { fieldName:"primaryEmail", type: "basic"},
      {fieldName:"vendorCategory",type:"dropdown"},
      { fieldName:"primaryPhone", type:"basic"},
      { fieldName:"primaryPhoneExt", type:"basic"},
      { fieldName:"userStatus", type:"dropdown"},
      { fieldName:"lastLoginDate", type:"date"},

    ];
    this.userStatusValues = [
      { description: 'All', id: 'All' },
      { description: 'Active', id: 'Active' },
      { description: 'Inactive', id: 'Inactive' }
    ];
  }
  checkViewPermission() {
    var permission =this.jwtService.getLoggedInUserProfile();
    var allowedUser = this.sharedService.isMspUser();
    if(permission ==0 || allowedUser == false || allowedUser == undefined)
    {
     this.router.navigateByUrl('/login');
    }
    this.getUserActivityLogGlobalFilter();
  }
  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }

  getUserActivityLogGlobalFilter() {
    this.categoryName = 'Log Period';
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.UserActivityLogReportGlobalFilter).subscribe((data:IUserActivityLog) => {
      this.userActivityLogGlobalFilterList = data;
      this.userActivityLogGlobalFilterList.sort((a, b) => (a.lookupOrder < b.lookupOrder) ? -1 : 1);
    });

  }
  getUserActivityLogGlobalFilterOnChange(event){
    this.logPeriodId = event.value.lookupOrder;
    this.logPeriodDescription = event.value.description;
    this.isLogPeriodSelected = true;
  }

  generateUserActivityLog({value} : {value: IUserActivityLog}, table:Table){
    table.clear();
    this.appliedFilters = [];
    this.lastLoginDateFilterValue = undefined;
    this.selectedUserStatus ="";
    this.getVendorCategoryForFilters();
    // value.logPeriodId = this.logPeriodId;
    this.appliedFilters.push({ field:"loggedInUserId", matchMode:"custom-equals", value:this.loggedInUserProfile.uid });
    this.showTable = true;
    if(this.logPeriodId === 1)
    {
      this.appliedFilters.push({ field:"inactive30days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 2)
    {
      this.appliedFilters.push({ field:"inactive60days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 3)
    {
      this.appliedFilters.push({ field:"inactive90days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 4)
    {
      this.appliedFilters.push({ field:"inactive90daysmore", matchMode:"custom-equals", value:"true" });  
    }
    
    this.userActivityLogSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       console.log('parma',this.userActivityLogSearchParam)
       this.spinner.show();
    this.userActivityLogService.searchUserActivityLog(this.userActivityLogSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.userActivityLogList =data;
      console.log('vn',this.userActivityLogList);
      this.isshowpaginator=this.userActivityLogList.length>0?true:false;
      this.totalRecords = (this.userActivityLogList === null || this.userActivityLogList === undefined || this.userActivityLogList.length <= 0 )? 0 : data[0].totalCount;
      console.log(this.totalRecords);
      this.spinner.hide();
     });  }

  getUserActivityLog(){
    
    if(this.logPeriodId === 1)
    {
      this.appliedFilters.push({ field:"inactive30days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 2)
    {
      this.appliedFilters.push({ field:"inactive60days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 3)
    {
      this.appliedFilters.push({ field:"inactive90days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 4)
    {
      this.appliedFilters.push({ field:"inactive90daysmore", matchMode:"custom-equals", value:"true" });  
    }
    
    this.userActivityLogSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       console.log('parma',this.userActivityLogSearchParam)
       this.spinner.show();
    this.userActivityLogService.searchUserActivityLog(this.userActivityLogSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.userActivityLogList =data;
      console.log('vn',this.userActivityLogList);
      this.isshowpaginator=this.userActivityLogList.length>0?true:false;
      this.totalRecords = (this.userActivityLogList === null || this.userActivityLogList === undefined || this.userActivityLogList.length <= 0 )? 0 : data[0].totalCount;
      console.log(this.totalRecords);
      this.spinner.hide();
     });
  }
  loadUserActivityLogList(event:LazyLoadEvent)
  { 
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getUserActivityLog();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
   
    if(this.filters["createdOn"] != undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButton = true;
    }
    else{
      this.showAddRuleButton = false;
    }
  }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getUserActivityLog();
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }
  clear(table:Table)
  {
    console.log(table);
    table.clear();
    // this.reactiveForm();
    // this.selectedReportIds="";
    // this.selectedReportEditIds =undefined;
    // this.selectedReportEditIdsOnChange =undefined;
    this.logPeriodId = [];
    this.isLogPeriodSelected = false;
    this.logPeriodDescription = undefined;
    this.selectedLogPeriodId = undefined;
    this.appliedFilters = [];
    this.lastLoginDateFilterValue = undefined;
    this.selectedUserStatus = "";
    this.selectedVendorCategory = "";
    this.userActivityLogList =[];
    this.isshowpaginator=false;
    // this.pageNo =1;
    // this.pageSize =10;
    // this.oldPageNo =1;
    // this.oldPageSize =10;
    // this.totalRecords = 0;
    // this.sortField = 'createdOn';
    // this.sortOrder = 'desc';
    // this.oldSortField = 'createdOn';
    // this.oldSortOrder = 'desc';
    this.showTable = false;
  }

  applyFilterNew() {
    this.pageNo = 1;
    this.table.first = 0;
    this.applyFilter();
  }

  applyFilter() {
    //  console.log(this.filters);
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              console.log("filter field name is " + [this.filterCondition[i].fieldName][0]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            // for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
            //   if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
            //     this.appliedFilters.push({
            //       field: this.filterCondition[i].fieldName,
            //       matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
            //       value: this.datePipe.transform(this.filters[this.filterCondition[i].fieldName][j].value, "MM-dd-yyyy")
            //     })
            // }



            if (this.filterCondition[i].fieldName == "lastLoginDate") {
              this.dateFilterValueSet(this.lastLoginDateFilterValue, "lastLoginDate")
            }

          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
        else if (this.filterCondition[i].type == "dropdown") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        if(this.filters['userStatus'] !==undefined)
        {
          if (this.filters['userStatus'][0].value !== null && this.filters['userStatus'][0].value != 0) {
            this.getSelectedUserStatus(this.userStatusValues,this.filters['userStatus'][0].value)
          }
          else{
            this.selectedUserStatus= "";
          }
        }
        if(this.filters['vendorCategory'] !==undefined)
        {
          if (this.filters['vendorCategory'][0].value !== null && this.filters['vendorCategory'][0].value != 0) {
            this.selectedVendorCategory = this.filters['vendorCategory'][0].value;
          }
          else{
            this.selectedVendorCategory= "";
          }
        }
        
      }
      if(this.logPeriodId === 1)
    {
      this.appliedFilters.push({ field:"inactive30days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 2)
    {
      this.appliedFilters.push({ field:"inactive60days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 3)
    {
      this.appliedFilters.push({ field:"inactive90days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 4)
    {
      this.appliedFilters.push({ field:"inactive90daysmore", matchMode:"custom-equals", value:"true" });  
    }
    
    this.userActivityLogSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       console.log('parma',this.userActivityLogSearchParam)
       this.spinner.show();
    this.userActivityLogService.searchUserActivityLog(this.userActivityLogSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.userActivityLogList =data;
      console.log('vn',this.userActivityLogList);
      this.isshowpaginator=this.userActivityLogList.length>0?true:false;
      this.totalRecords = (this.userActivityLogList === null || this.userActivityLogList === undefined || this.userActivityLogList.length <= 0 )? 0 : data[0].totalCount;
      console.log(this.totalRecords);
      this.spinner.hide();
     });
    }
  }
  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.lastLoginDateFilterValue = undefined;
    this.selectedUserStatus ="";
    this.selectedVendorCategory = "";
    // this.applyFilter();
    this.getUserActivityLog();
  }
  getSelectedUserStatus(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.id == id);
      this.selectedUserStatus= tempStatus[0].description;
    } else {
      return "";
    }
  }

  lastLoginDateFilterData(e: any) {
    this.lastLoginDateFilterValue = e;
    this.applyFilter();
  }
  dateFilterValueSet(value, fieldName) {
    if (value !== undefined) {
      for (let j = 0; j < value.length; j++) {
        if (value[j].valueControl !== null) {
          this.appliedFilters.push({
            field: fieldName,
            matchMode: value[j].matchModeControl,
            value: this.datePipe.transform(value[j].valueControl, "MM-dd-yyyy")
          })
        }
      }
    }
  }

  exportUserActivityLogReport(){
    if(this.logPeriodId === 1)
    {
      this.appliedFilters.push({ field:"inactive30days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 2)
    {
      this.appliedFilters.push({ field:"inactive60days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 3)
    {
      this.appliedFilters.push({ field:"inactive90days", matchMode:"custom-equals", value:"true" });  
    }
    else if (this.logPeriodId === 4)
    {
      this.appliedFilters.push({ field:"inactive90daysmore", matchMode:"custom-equals", value:"true" });  
    }
    this.applyFilter();
    this.userActivityLogSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       console.log('parma',this.userActivityLogSearchParam)
       this.spinner.show();
       this.userActivityLogService.exportUserActivityLogReport(this.userActivityLogSearchParam).subscribe(res => {
        var blob = new Blob([res.body], { type: res.body.type });
        const file = new File([blob],"UserActivityLogReport.xlsx", { type: res.body.type });
        fs.saveAs(file);
        });
        this.spinner.hide();
  }

getVendorCategoryForFilters()
{
  this.sharedService.getLookupMasterByCategoryId(LookupCategory.ClientListForRegistration).subscribe((data: any) => {
  this.allVendorCategories = data;
  this.arrVendorCategories= this.allVendorCategories;
  this.arrVendorCategories.push({categoryId:0,createdBy:0,createdByUser:null,createdOn: null,description:"All",isActive: true,
  lookupCategory: null,
  lookupId: 0,
  lookupOrder: 0,
  modifiedBy: 0,
  modifiedByUser: null,
  modifiedOn: null});
  this.arrVendorCategories.sort((a, b) => (a.description < b.description) ? -1 : 1);
  this.allVendorCategories = this.arrVendorCategories;
  for(var a=0;a<this.arrVendorCategories.length;a++)
  {
    if(this.arrVendorCategories[a].description == 'DevCare - Requisition and Invoice')
    {
      this.arrVendorCategories[a].description = 'Requisition and Invoice';
    }
    if(this.arrVendorCategories[a].description == 'DevCare - Subcontractor Invoice only')
    {
      this.arrVendorCategories[a].description = 'Invoice Only';
    }
  }
  });
}

}
